<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" width="580px">
      <div class="main">
        <div class="banner">
          <img src="@/assets/img/1688/bg.png" alt="">
          <h6>アカウント情報確認</h6>
          <p>既に1688またはtaobaoサイトでアカウント登録ご利用済みの携帯番号はご利用できませんので予めご了承ください。</p>
        </div>
        <!--注意事项  -->
        <div class="text" v-if="step == 1">
          <h6>注意事項</h6>
          <p>
            1.こちらで登録されるアカウントについて、弊社は代わりに登録する作業を簡易にするものであり、所有権及び管理はお客様自身になります。<br>
            2.不正利用など発覚される場合はアリババの規則に従い凍結などされることがありますので、予めご了承ください。<br>
            3.　弊社サービスを利用せず、アリババアカウントのみご利用される場合や弊社への登録情報の虚偽等の不適切なご利用についても中止させて頂く事がございます。<br>
            4.通話が出来ないSMS・データ専用の番号でご登録の場合、緊急時や通関等のお取引に支障がございますので、ご利用を中止させて頂く事がございます。<br>
            5.アリババアカウントの転売や貸与、第三者利用が疑われる場合は、ご利用を中止させて頂きます。</p>
          <div class="btn">
            <el-button type="primary" size="small" @click="step = 2"> 上記に同意、次へ</el-button>
          </div>

        </div>
        <!-- 同步 -->
        <div class="synchronization1688 text" v-else-if="step == 2">
          <div class="label">携帯番号：</div>
          <div class="input">
            <el-input v-model="userInfo.mobile" size="mini" @input="setCode">
            </el-input>
          </div>
          <div class="label" v-if="isCode">認証コード：</div>
          <div class="input" v-if="isCode">
            <el-input v-model="code" size="mini">
              <el-button slot="append" size="mini" @click="clientCodeImg" v-if="show">確認コード取得</el-button>
              <el-button slot="append" size="mini" v-else>{{ Countdown }}</el-button>
            </el-input>
          </div>
          <div class="label">Email：</div>
          <div class="input">
            <el-input v-model="userInfo.email" size="mini">
            </el-input>
          </div>
          <div class="btn">
            <el-button type="primary" size="small" @click="checkRegisterCode" v-if="isCode"> 記載完了、同期へ</el-button>
            <el-button type="primary" size="small" @click="alibabaUserRegister" v-if="!isCode">
              記載完了、同期へ</el-button>
          </div>

        </div>
        <!--同步成功  -->
        <div class="success text" v-else-if="step == 3">
          <div class="head">
            <i class="el-icon-success"></i>アカウント同期作成完了
          </div>
          <div class="section">
            ＊アリババ初回のログインはパスワードが設定されていないため、携帯番号で認証コード取得する形でのログインになります。<br>
            ＊こちらのアカウントは日本国内のみのご利用になっており、VPNやIP変動ツールの利用により、アカウント凍結される場合がございますので、予めご了承ください。
          </div>
          <div class="btn">
            <a href="https://www.1688.com/"> <el-button type="primary" size="small" @click="checkRegisterCode">
                １６８８ログインへ</el-button></a>
          </div>
          <div class="footer">
            <span class="footerLeft">商品リサーチ及びラクマートサイトへ追加するため、RAKUMARTの拡張機能をお勧めします。 <span class="footerRight"
                @click="download">ダウンロードへ</span></span>
          </div>
        </div>
      </div>

    </el-dialog>
    <!-- 图形验证码 -->
    <el-dialog :visible.sync="imgDialogVisible" width="580px">
      <div class="imgCode">
        <div class="img">
          <img :src="image" alt="">
          <div class="btn">
            <el-button type="primary" @click='clientCodeImg'>
              リセット
            </el-button>
          </div>
        </div>
        <div class="code">
          <el-input v-model="imgCode" placeholder="画像内の文字列をご入力ください"></el-input>
          <el-button type="primary" @click="sendSMS">
            確認
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { clientCodeImg, sendSMS, checkRegisterCode, alibabaUserRegister } from '../../api/API/login'
export default {
  data() {
    return {
      dialogVisible: false, //弹框
      imgDialogVisible: false, // 验证码弹框
      step: 1, //步骤
      userInfo: JSON.parse(localStorage.getItem('userInfo')),//个人信息
      imgCode: '',//图形code
      image: '',//图片
      code: '', // 收到的短信验证码
      show: true,//显示倒计时
      Countdown: 60,//倒计时
      mobile: '',
      isCode: false,
    };
  },


  created() {
    this.mobile = this.userInfo ? this.userInfo.mobile : this.mobile

  },
  methods: {
    setCode() {
      this.isCode = this.mobile == this.userInfo.mobile ? false : true
    },
    // 获取图形验证码
    clientCodeImg() {
      let datas = {
        rand: Math.floor(Math.random() * 10),
        number: this.userInfo.mobile
      }
      clientCodeImg(datas).then(res => {
        this.image = res.data.image
        this.imgDialogVisible = true

      })
    },
    //发送验证码
    sendSMS() {
      let datas = {
        number: this.userInfo.mobile,
        captcha: this.imgCode,
        is1688AccountCreate: 1
      }
      sendSMS(datas).then(res => {
        if (res.code != 0) this.$message.error(res.msg)
        this.imgDialogVisible = false
        this.show = false
        var timer = setInterval(() => {
          this.Countdown -= 1;
          if (this.Countdown <= 0) {
            this.show = true;
            this.Countdown = 60;
            clearInterval(timer);
          }
        }, 1000);
        console.log(res);
      })
    },
    //校验验证码
    checkRegisterCode() {
      let datas = {
        number: this.userInfo.mobile,
        code: this.code
      }
      checkRegisterCode(datas).then(res => {
        if (res.code != 0) return this.$message.error(res.msg)
        let data = {
          email: this.userInfo.email,
          mobile: this.userInfo.mobile,
          realname: this.userInfo.realname,
          id: this.userInfo.id,
          token: localStorage.getItem('token')
        }

        // 注册1688
        alibabaUserRegister(data).then(result => {
          if (result.code != 0) return this.$message.error(result.msg)
          this.step = 3
        })
      })
    },
    // 不需要验证直接
    alibabaUserRegister() {
      let data = {
        email: this.userInfo.email,
        mobile: this.userInfo.mobile,
        realname: this.userInfo.realname,
        id: this.userInfo.id,
        token: localStorage.getItem('token')
      }
      // 注册1688
      alibabaUserRegister(data).then(result => {
        if (result.code != 0) return this.$message.error(result.msg)
        this.step = 3
      })
    },
    // 下载插件
    download() {
      window.open('https://chromewebstore.google.com/detail/rakumart%E7%84%A1%E5%9C%A8%E5%BA%AB%E4%BE%BF/jbchdlpihmdihmlacmdgieoedmpbgmng?hl=ja&utm_source=ext_sidebar')
    },
  }
}
</script>
<style lang='scss' scoped>
/deep/ .el-dialog__header {
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0;
}

/deep/.el-dialog__close {
  font-size: 18px;
  color: #333;
  font-weight: 600;
}

.main {
  display: flex;

  .banner {
    width: 285px;
    position: relative;

    img {
      height: 100%;
    }

    h6 {
      font-size: 24px;
      color: #fff;
      position: absolute;
      top: 36px;
      text-align: center;
      width: 280px;
    }

    p {
      font-size: 14px;
      color: #fff;
      position: absolute;
      top: 76px;
      text-align: center;
      width: 260px;
      left: 10px;

    }
  }

  .text {
    width: 250px;
    margin: 40px 20px 20px;
    height: 292px;
    overflow-y: auto;

    h6 {
      margin-bottom: 15px;
    }

    p {
      width: 100%;
      color: #999999;
      margin-bottom: 20px;
    }

    .el-button {
      width: 100%;
      height: 34px;

      border-radius: 8px;
    }

    .btn {
      margin-top: 20px;
    }

    .label {
      margin-bottom: 10px;
    }

    .input {
      width: 100%;
      padding: 0;
      margin-bottom: 10px;
    }
  }
}

.imgCode {
  padding: 60px;

  .img {
    display: flex;

    img {
      flex: 1;
    }

  }

  .el-button {
    margin-left: 30px;
    width: 100px;
    height: 40px;

  }

  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .code {
    display: flex;
    margin-top: 30px;

    .el-input {
      flex: 1;
    }
  }
}

.success {
  margin-top: 60px;

  .head {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }

  .el-icon-success {
    font-size: 30px;
    color: #50C136;
    vertical-align: middle;
    margin-right: 10px;
  }

  .section {
    font-size: 12px;
  }

  .footer {
    margin-top: 5px;
    font-size: 12px;

    .footerRight {
      cursor: pointer;
      float: right;
      color: #50C136;
      text-decoration: underline;
    }
  }
}

/deep/.el-input-group__append {
  background-color: #fff;
  color: #f3c622;
}
</style>